/**
 * Polyfill for ReactDOM.findDOMNode for React 19
 * This is needed for legacy libraries (semantic-ui-react, react-images-upload) that haven't updated yet
 * Note: findDOMNode is deprecated and removed in React 19. This is a temporary workaround.
 */

const ReactDOM = require('react-dom');

// Only add polyfill if findDOMNode doesn't exist (React 19+)
if (!ReactDOM.findDOMNode) {
  // Add findDOMNode polyfill
  ReactDOM.findDOMNode = function(component) {
    if (component == null) {
      return null;
    }
    
    // If it's already a DOM node, return it
    if (component.nodeType === 1) {
      return component;
    }
    
    // For React components, try to access the DOM node
    // In React 19, we don't have direct access to internals, so this is limited
    try {
      // Check if it has stateNode (class components)
      if (component._reactInternals?.stateNode) {
        const node = component._reactInternals.stateNode;
        if (node && node.nodeType === 1) {
          return node;
        }
      }
      
      // Check alternate approach for fiber
      if (component._reactInternals?.child?.stateNode) {
        const node = component._reactInternals.child.stateNode;
        if (node && node.nodeType === 1) {
          return node;
        }
      }
    } catch (e) {
      // Suppress errors in accessing internals
    }
    
    // Last resort - return null and suppress warning in production
    if (process.env.NODE_ENV === 'development') {
      console.warn('findDOMNode is deprecated. Library using it should be updated.');
    }
    return null;
  };
}
